import type { CSSProperties, LinariaClassName } from '@linaria/core';
import { cx } from '@linaria/core';
import { memo } from 'react';
import Crown from '../../../Icons/Crown';
import Container, { ContainerProps } from '../Container';
import "./PriorMissMFC.linaria.module.css!=!./PriorMissMFC?./PriorMissMFC.linaria.module.css?css=H4sIAAAAAAAAA4WPy04DIRhG9z6FGxNd0JRJte34MITh3jL84w9zk/juxtqOMjFx+cE5J7DhqWVaMGpf4NS/b8qZT31MTs9EQEgqpFqokBS+ftxdQFtoy8rcOxOIS6qNK+P5xCjEN6iG3ABKhQS5dH2s6Xb7cIOOkdE0jW7wWbrYeT7X2qvpdq2qpWGVMzYVsgeWjrs5xXLljkvpgiEJupp2S8yrAldrvIGUoC2Mc2Gc14ZXOhW8L3i/5vH7Cz/CEa0dGd0FPSV1HweTBXjAeuD4SEjrYiStFqRDB0hGF4JCIhDGQJyA8HTLVJLt+8E0uly54eJsEPogyZ9dA17+jlBzoAhyNf/NROcHhUtov2W0cr2tDrmBiUTLJYxXx/NZ4eXx1/Mv6xNsBYsomQIAAA=="
const missMfcStyles = "atm_fc_1h6ojuz atm_h_1h6ojuz atm_5j_1osqo2v atm_9s_1txwivl atm_e2_1osqo2v atm_lo_t94yts atm_le_t94yts atm_lk_t94yts atm_ll_t94yts atm_9rhhw_14nfxte";
const stylesMissMFCGold = "atm_2d_7uvgbf";
const stylesMissMFCSilver = "atm_2d_1g81rod";
const stylesBoxShadow = "atm_70_12iuh28";
interface PriorMissMFCBadgeProps {
  containerProps?: Partial<ContainerProps>;
  priorMissMfcRank?: number;
  shadow?: boolean;
  className?: LinariaClassName;
  style?: CSSProperties;
}
const PriorMissMFCBadge = memo((props: PriorMissMFCBadgeProps) => {
  const {
    containerProps = {},
    priorMissMfcRank,
    shadow = true,
    className,
    style
  } = props;
  if (!priorMissMfcRank) {
    return null;
  }
  return <Container title="Prior Miss MFC Winner" {...containerProps} shadow={shadow}>
            <div className={cx(priorMissMfcRank === 1 ? stylesMissMFCGold : stylesMissMFCSilver, shadow && stylesBoxShadow, missMfcStyles, className)} style={style}>
                <Crown />
            </div>
        </Container>;
});
export default PriorMissMFCBadge;
export { PriorMissMFCBadge };